import React, { useEffect, useRef, useState } from "react";

// components
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { ExpandLess, ExpandMore, Search as SearchIcon } from "@mui/icons-material";
import PDFGenerator from "../../helpers/PDFGenerator";

import { connect } from "react-redux";
import {
  Alert,
  Box,
  Button,
  Chip,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  CardContent,
  Card,
  Typography,
  Grid,
  TextField,
} from "@mui/material";
import a11yProps from "../../helpers/ay-props";
import TabPanel from "../../helpers/TabPanel";
import { useHistory, useParams } from "react-router";
import {
  getError,
  getSuccessMessage,
} from "../../store/helpers/common_functions";
import PageLoading from "../../helpers/PageLoading";
import moment from "moment";

import classes from "./profile.module.css";
import FormDialog from "../../helpers/FormDialog";
import { StyledTableRow } from "../../helpers/CustomMenu";
import Add from "@mui/icons-material/Add";
// import { ResourceFormDialog } from "./Resource";
import { errorToast, successToast } from "../../helpers/Notification";
import { CheckHasAnyPermission, getFileMime } from "../../helpers/Common_functions";
import OpenDocuments from "../../helpers/openDocument";
import StatusLayout from "components/Status";
import Acting from "components/Resource/Acting";
import EmployeeDocuments from "./EmployeeDocuments";
import { BsPencil } from "react-icons/bs";
import { EducationEdit } from "../../components/Modal/EducationEdit";
import { ReferenceEdit } from "../../components/Modal/ReferenceEdit";
import ParentsEdit from "../../components/Modal/ParentsEdit";
import { EmployementHistoryEdit } from "../../components/Modal/EmployementHistoryEdit";
import { RelativeDetailsEdit } from "../../components/Modal/RelativeDetailsEdit";
import { LeadershipEdit } from "components/Modal/LeadershipEdit";
import { CriminalRecordEdit } from "../../components/Modal/CriminalRecordEdit";
import { DiasporaDetailsEdit } from "../../components/Modal/DiasporaDetailsEdit";
import CivilStatusEdit from "components/Modal/CivilStatusEdit";
import CurrentResidenceEdit from "../../components/Modal/CurrentResidenceEdit";
import { AllocateEmployee } from "../../components/Modal/AllocateEmployee";
import ProfileWorklogReport from "./ProfileWorklogReport";

import DatatableComponent from "../../helpers/DatatableComponent";
import { Select, MenuItem } from "@mui/material";


export const ProjectWorkedOn = ({
  project,
  mainBackground,
  resourceId,
  SubmitGeneralForm,
  FetchDetails,
}) => {
  const [open, setOpen] = useState(0);
  const [value, setValue] = useState({});
  const [allProjects, setAllProjects] = useState([]);
  const [count, setCount] = useState(0);
  const [list, setList] = useState([]);
  const [projectSearchText, setProjectSearchText] = useState("");


  const history = useHistory();

  const fetchAllProjects = React.useCallback(async () => {
    const resp = await FetchDetails(`api/project/unassigned/${resourceId}`);
    setAllProjects(resp.data?.projects || []);
  }, [FetchDetails, resourceId]);
  // const fetchProject = async () => {
  //   const resp = await FetchDetails(`api/project/listAll`);
  //   const data = resp.data?.data;

  //   if (resp.status) {
  //     setAllProjects(data)
  //   }
  // }

  useEffect(() => {
    fetchAllProjects();
  }, [resourceId, count]);


  const setValue0 = (name, val) => setValue((v) => ({ ...v, [name]: val }));

  const columns = [
    {
      name: "code",
      label: "Code",
    },
    {
      name: "name",
      label: "Name",
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        customBodyRender: (value) => moment(value).format("YYYY-MM-DD"),
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        customBodyRender: (value) => moment(value).format("YYYY-MM-DD"),
      },
    },
    {
      name: "budget",
      label: "Budget",
    },
    {
      name: "impact",
      label: "Impact",
    },
    // {
    //   name: "performance",
    //   label: "Performance",
    // },
    {
      name: "status",
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          Status
          {CheckHasAnyPermission("action.assign.project") && (

            <Button
              onClick={() => {
                setValue({});
                setOpen(1);
              }}
              size="small"
              style={{
                backgroundColor: mainBackground,
                color: "#fff",
                marginLeft: 8,
              }}
              startIcon={<BsPencil />}
            >
              Assign
            </Button>
          )}
        </span>
      ),
      options: {
        customBodyRender: (value) => <StatusLayout status={value} />,
      },
    },

  ];

  const onSuccess = () => setCount(v => v + 1);

  return (

    <>
      <DatatableComponent
        columns={columns}
        title="Assigned Projects"
        viewColumns={false}
        search={false}

        url={`/api/project/assigned/${resourceId}?count=${count}`}
        processData={(data) => {
          setList(data.projects);
          return {
            data: data.projects || [],
            recordsFiltered: (data.projects || []).length,
            page: 0,
          };
        }}
        onRowClick={(data, { rowIndex }) => {
          history.push(`/admin/project/details/${list[rowIndex].id}`);
        }}
        addButtonProps={{
          style: { backgroundColor: mainBackground, color: "#fff" },
          startIcon: <BsPencil />,
          children: "Assign",
        }}
        elevation={1}
      />

      <FormDialog
        maxWidth="md"
        open={open > 0}
        setOpen={setOpen}
        title="Assign to a Project"
        url={`/api/project/assign/user/${resourceId}`}
        onSuccess={onSuccess}
        fields={[
          {
            name: "projectId",
            label: "Project",
            render: () => {
              const filteredProjects = allProjects.filter((proj) =>
                proj.name.toLowerCase().includes(projectSearchText.toLowerCase()) ||
                proj.code.toLowerCase().includes(projectSearchText.toLowerCase())
              );

              const selectedProjectId = value["projectId"];

              return (
                <div>
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                    <TextField
                      placeholder="Search projects by name or code..."
                      size="small"
                      value={projectSearchText}
                      onChange={(e) => setProjectSearchText(e.target.value)}
                      style={{ width: "100%", maxWidth: 300, marginRight: 8 }}
                    />
                  </div>

                  <TableContainer style={{ maxHeight: 300, overflowX: "auto" }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell>#</TableCell>
                          <TableCell>Code</TableCell>
                          <TableCell>Name</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredProjects.map((proj, idx) => (
                          <TableRow
                            key={proj.id}
                            hover
                            selected={selectedProjectId === proj.id}
                            style={{
                              cursor: "pointer",
                              backgroundColor: selectedProjectId === proj.id ? "#f0f0f0" : undefined,
                            }}
                            onClick={() => setValue0("projectId", proj.id)}
                          >
                            <TableCell>
                              <input
                                type="radio"
                                name="project"
                                checked={selectedProjectId === proj.id}
                                onChange={() => setValue0("projectId", proj.id)}
                              />
                            </TableCell>
                            <TableCell>{idx + 1}</TableCell>
                            <TableCell>{proj.code}</TableCell>
                            <TableCell>{proj.name}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              );
            },
            value: value["projectId"],
            setValue: (val) => setValue0("projectId", val),
            col: 12,
          },
        ]}
      />

    </>
  );
};

export const MeetingAttended = ({
  resourceId, resource
}) => {
  const history = useHistory();
  const [email, setEmail] = useState(0);
  const [list, setList] = useState([]);


  useEffect(() => {
    setEmail(resource?.resource?.email)
  }, [resource, email]);


  const columns = [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "Room.name",
      label: "Venue",
      options: {
        customBodyRenderLite: function (dataIndex, rowIndex) {
          const meeting = list[rowIndex];
          if (meeting?.Room === null || meeting?.roomId === null) {
            return "Virtual Meeting";
          }
          return meeting?.Room?.name || meeting?.venue || "N/A";
        },
      },
    },
    {
      name: "start",
      label: "Start Date",
      options: {
        customBodyRender: (value) => moment(value).format("YYYY-MM-DD hh:mm A"),
      },
    },
    {
      name: "end",
      label: "End Date",
      options: {
        customBodyRender: (value) => moment(value).format("YYYY-MM-DD hh:mm A"),
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        customBodyRender: (value) => <Chip size="small" label={value} />,
      },
    },
  ];

  return (
    <DatatableComponent
      columns={columns}
      title="Meetings Attended"
      processData={(data) => {
        setList(data.meeting || []);
        return {
          data: data.meeting || [],
          recordsFiltered: (data.meeting || []).length,
          page: 0,
        };
      }}

      search={false}
      viewColumns={false}
      // pagination={false}
      url={`/api/meeting/attended/${email}`}
      onRowClick={(data, { rowIndex }) => {
        history.push(`/admin/meeting/details/${list[rowIndex].id}`);
      }}
    />
  )
}


export const PersonalLeaves = ({ resourceId, resource }) => {

  const date = new Date();
  const history = useHistory();
  const [list, setList] = useState([]);
  const [year, setYear] = useState(date.getFullYear());
  const [url, setUrl] = useState(`/api/annual/fetch/${resourceId}?year=${date.getFullYear()}`);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);


  const calculateDaysRemaining = (endDate) => {
    const end = moment(endDate, "YYYY-MM-DD");
    if (!end.isValid()) {
      return 0;
    }
    const currentDate = moment();
    const daysRemaining = end.diff(currentDate, "days");
    return Math.max(daysRemaining, 0);
  };

  useEffect(() => {
    setUrl(`/api/annual/fetch/${resourceId}?year=${year}`);
  }, [year, resourceId]);

  const columns = [
    {
      name: "category.name",
      label: "Leave Type",
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        customBodyRender: (value) => moment(value).format("YYYY-MM-DD"),
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        customBodyRender: (value) => moment(value).format("YYYY-MM-DD"),
      },
    },
    // {
    //   name: "leaveDays",
    //   label: "Days Taken",
    //   options: {
    //     customBodyRenderLite: (dataIndex, rowIndex) => {
    //       const row = list[rowIndex];
    //       const startDate = row?.startDate;
    //       const endDate = row?.endDate;
    //       const status = row?.status?.toLowerCase?.() || "";
    //       if (!startDate) return 0;
    //       const start = moment(startDate, "YYYY-MM-DD");
    //       if (!start.isValid()) return 0;

    //       let end;
    //       if (status === "on-leave") {
    //         end = moment().startOf("day");
    //       } else if (endDate && moment(endDate, "YYYY-MM-DD").isValid()) {
    //         end = moment(endDate, "YYYY-MM-DD");
    //       } else {
    //         end = moment().startOf("day");
    //       }

    //       let businessDaysTaken = start.businessDiff(end);
    //       if (businessDaysTaken < 0) businessDaysTaken = 0;
    //       return <Typography>{businessDaysTaken}</Typography>;
    //     },
    //   },
    // },
    {
      name: "leaveDays",
      label: "Days Taken",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const row = list[rowIndex];
          const startDate = moment(row?.startDate);
          const endDate = moment(row?.endDate);
          return startDate.isValid() && endDate.isValid()
            ? startDate.businessDiff(endDate)
            : "N/A";
        },
      },
    },
    {
      name: "id",
      label: "Days Left",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const endDate = list[rowIndex]?.endDate;
          const daysRemaining = calculateDaysRemaining(endDate);
          return <Typography>{daysRemaining}</Typography>;
        },
      },
    },

    {
      name: "status",
      data: "status",
      label: "Status",
      options: {
        customBodyRender: (v) => <StatusLayout status={v} />,
      },
    },

  ];
  return (
    <DatatableComponent
      columns={columns}
      title={
        <div className="flex items-center">
          <span className={"mr-2"}>
            <Typography variant={"h6"}>{resource?.resource.names + " Leaves" || "Personal Leaves"}</Typography>
          </span>
          <span className={"flex-grow ms-2"}>
            <Select
              value={year}
              onChange={e => setYear(e.target.value)}
              displayEmpty
              size="small"
              style={{ background: "#fff" }}
            >
              <MenuItem value="" disabled>
                Select year
              </MenuItem>
              {years.map(y => (
                <MenuItem key={y} value={y}>{y}</MenuItem>
              ))}
            </Select>
          </span>
        </div>
      }
      processData={(data) => {
        setList(data.data || []);
        return {
          data: data.data || [],
          recordsFiltered: (data.data || []).length,
          page: 0,
        };
      }}
      search={false}
      viewColumns={false}
      url={url}
      onRowClick={(data, { rowIndex }) => {
        history.push(`/admin/permission/details/${list[rowIndex].id}`);
      }}
    />
  );
};

const CollapsibleDetailsSection = ({ title, children, mainBackground }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <div style={{ marginTop: "16px" }}>
      <Box
        onClick={handleToggle}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          padding: "8px 16px",
          borderRadius: "4px",
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: mainBackground,
            fontSize: "16px",
          }}
        >
          {title}
        </Typography>
        {expanded ? <ExpandLess /> : <ExpandMore />}
      </Box>

      {/* Modified Box with print styles */}
      <Box
        sx={{
          marginTop: "8px",
          padding: "16px",
          borderRadius: "4px",
          display: expanded ? "block" : "none",
          "@media print": {
            display: "block !important",
            visibility: "visible !important",
            height: "auto !important",
          },
        }}
      >
        {children}
      </Box>
    </div>
  );
};
function ResourceProfile({
  FetchDetails,
  SubmitGeneralForm,
  technologies,
  GetTechnologies,
  GetAllMeetingList,
  meetingList,
  ViewAllQualification,
  loggedUser,
  GetLoggedUser,
  GetAllResources,
  structures,
  resourceId,
  systemSettings,
  leaveList,
  wholeStructure
}) {
  const mainBackground = systemSettings?.mainBackground;

  const history = useHistory();
  const [value, setValue] = React.useState({});
  const [positions, setPositions] = React.useState([]);
  const [valueTab, setTabValue] = React.useState(0);

  const [viewActing, setViewActing] = React.useState();
  const [openActing, setOpenActing] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [loading0, setLoading0] = React.useState(false);
  const [openTech, setOpenTech] = React.useState(false);
  const [error, setError] = React.useState();
  const [info, setInfo] = React.useState({});
  const [openEdit, setOpenEdit] = React.useState(0);
  const [openAllocateEmployee, setOpenAllocateEmployee] = React.useState(0);
  const [openCurrentResidence, setOpenCurrentResidence] = React.useState(0);
  const [project, setProject] = React.useState();
  const [newTechnologies, setNewTechnologies] = useState([]);
  const printRef = useRef();
  const [count, setCount] = React.useState(0);

  const [attachmentOpen, setAttachmentOpen] = React.useState(false);
  const [openEducation, setOpenEducation] = React.useState(0);
  const [openReference, setOpenReference] = React.useState(0);
  const [openParents, setOpenParents] = React.useState(0);
  const [openLeadership, setOpenLeadership] = React.useState(0);
  const [openCriminalRecord, setOpenCriminalRecord] = React.useState(0);
  const [openEmployement, setOpenEmployment] = React.useState(0);
  const [openRelative, setOpenRelative] = React.useState(0);
  const [openDiaspora, setOpenDiaspora] = React.useState(0);
  const [openCivilStatus, setOpenCivilStatus] = React.useState(0);

  const [resource, setResource] = React.useState({});
  const [linemanager, setLineManager] = React.useState({});


  const success = () => setCount((v) => v + 1);

  const changeEmpDetails = "action.change.employee.details";
  const employeeOtherDetails = "action.view.other.details";


  const hasPendingRequest =
    info?.actingOnBehalf?.filter((acting) => acting?.status === "pending") ??
    [];

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const loadPositions = async () => {
    const resp = await FetchDetails(`/api/staff-position/viewAll`);
    if (resp.status) {
      const positionList = resp?.data?.list?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setPositions(positionList);
    }
  };


  const newTechnologySubmit = async () => {
    if (!newTechnologies.length) {
      return;
    }

    setLoading0(true);
    const resp = await SubmitGeneralForm("/api/profile/create/pending/tech", {
      technologies: newTechnologies,
    });
    setLoading0(false);
    if (resp.status) {
      setOpenTech(false);
      setNewTechnologies([]);
      onSuccess();
      successToast(getSuccessMessage(resp));
    } else {
      errorToast(getError(resp));
    }
  };

  const { id } = useParams();
  const isMe = id === loggedUser?.resourceId;


  const loadData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await FetchDetails(`/api/resource/details/${isMe ? loggedUser?.resourceId : id}`)
      setLineManager(response?.data?.myLineManagers || {});
      // console.log("response", response);

      if (response.status) {
        const {
          projects
        } = response?.data

        let inf0 = { ...project, projects: projects ?? [] };
        setProject(inf0);
        setInfo(response?.data);
        setResource(response?.data)
      }
      else {
        throw new Error(getError(response));
      }

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const linemanagerId = linemanager[0]?.userId || "";
  // console.log("linemanagerId", linemanager);
  // console.log("loggedUser", loggedUser);

  const isLineManager = linemanagerId === loggedUser?.id;
  // console.log("linemanagerId", linemanagerId);
  useEffect(() => {
    //   // GetTechnologies("/api/profile/technologies");
    loadPositions().then();
  }, []);

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((prev) => {
      const updatedValues = { ...prev, [name]: val };

      // Handle dependent field clearing and data loading
      switch (name) {

        case "leadershipPosition":
          if (val === "no") {
            updatedValues["leaderName"] = "";
            updatedValues["leaderRelationship"] = "";
            updatedValues["position"] = "";
          }
          break;

        case "isAbroad":
          if (val === "no") {
            updatedValues["abroadName"] = "";
            updatedValues["abroadRelationship"] = "";
          }
          break;

        case "beenImprisoned":
          if (val === "no") {
            updatedValues["imprisonmentReason"] = "";
            updatedValues["imprisonmentDuration"] = "";
            updatedValues["startDate"] = "";
            updatedValues["endDate"] = "";
            updatedValues["location"] = "";
          }
          break;
        case "livedAbroad":
          if (val === "0") {
            updatedValues["country"] = "";
            updatedValues["address"] = "";
            updatedValues["isParent"] = 0;
          }
          break;

        default:
          break;
      }

      if (Array.isArray(val)) {
        updatedValues[name] = [...val];
      }

      return updatedValues;
    });
  };

  useEffect(() => {
    const query = `profileUserId=${id}`;
    GetAllMeetingList(query);
  }, []);

  useEffect(() => {
    if (loggedUser) {
      loadData().then();
    }
    ViewAllQualification(id);
  }, [id, loggedUser]);

  const inputRef = useRef();
  const handleClick = () => {
    inputRef.current.click();
  };

  const updateProfile = async (file) => {
    setLoading(true);
    let formData = new FormData();
    if (file) {
      for (let i = 0; i < file.length; i++) {
        formData.append("profile", file[i]);
      }
    }
    try {
      const resp = await SubmitGeneralForm(`/api/profile/update/${id}`, formData);
      if (resp.status) {
        const updatedInfo = { ...info, profile: resp.data };
        setInfo(updatedInfo);
        loadData();

        successToast(getSuccessMessage(resp));
      } else {
        errorToast(getError(resp));
      }
    } catch (error) {
      errorToast("An error occurred while updating the profile picture.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (valueTab === 1) {
      setAttachmentOpen(true);
    }
  }, [valueTab]);

  const editCurrentResidence = async () => {
    setOpenCurrentResidence(2);
    const currentResidence = info?.resource || {};
    const currentResidenceData = {
      province: currentResidence.province || "",
      district: currentResidence.district || "",
      sector: currentResidence.sector || "",
      cell: currentResidence.cell || "",
      village: currentResidence.village || "",
      houseNo: currentResidence.houseNo || "",
      villageLeaderMobile: currentResidence.villageLeaderMobile || "",
      villageLeaderName: currentResidence.villageLeaderName || "",
    }
    setValue(currentResidenceData);
  };

  const editProfile = async () => {
    // setOpenEdit(2);
    setOpenAllocateEmployee(2);

    let data = info?.resource;
    let names = data?.names;
    let entryDate = data?.entryDate
      ? data?.entryDate.split("T")[0]
      : "";

    data = {
      ...data,
      names,
      entryDate,

    };
    setValue(data);
  };

  const editEducation = async () => {
    setOpenEducation(2);

    const educationRecords =
      info?.educationHistory?.map((record) => ({
        institution: record.institution || "",
        location: record.location || "",
        fieldOfStudy: record.fieldOfStudy || "",
        degreeDiploma: record.degreeDiploma || "",
        classOfDegree: record.classOfDegree || "",
        startYear: record.startYear ? record.startYear.split("T")[0] : "",
        endYear: record.endYear ? record.endYear.split("T")[0] : "",
      })) || [];

    setValue({ educationRecords });
  };

  const editReferences = async () => {
    setOpenReference(2);
    const referenceRecord =
      info?.references?.map((reference) => ({
        name: reference.name || "",
        relationship: reference.relationship || "",
        phone: reference.mobileNumber || "",
        customRelationship: reference.customRelationship || "",
        address: reference.address || "",
      })) || [];

    setValue({ referees: referenceRecord });
  };

  const editRelative = async () => {
    setOpenRelative(2);

    const relativeRecord =
      info?.family?.map((record) => ({
        relationType: record.relationType || "",
        relationName: record.relationName || "",
        placeOfWork: record.placeOfWork || "",
        country: record.country || "",
        mobileNumber: record.mobileNumber || "",
      })) || [];

    setValue({ relations: relativeRecord });
  };

  const editCriminalRecord = async () => {
    setOpenCriminalRecord(2);
    const criminalRecord = info?.criminalRecord || {};
    const criminalRecordData = {
      location: criminalRecord.location || "",
      imprisonmentReason: criminalRecord.reason || "",
      startDate: criminalRecord.startDate
        ? criminalRecord.startDate.split("T")[0]
        : "",
      endDate: criminalRecord.endDate
        ? criminalRecord.endDate.split("T")[0]
        : "",
      duration: criminalRecord.duration || "",
      beenImprisoned: criminalRecord.imprisoned ? "yes" : "no",
    };
    setValue(criminalRecordData);
  };

  const editLeadership = async () => {
    setOpenLeadership(2);

    const leadershipRecord =
      info?.leadership?.map((record) => ({
        leadershipPosition: record.isLeader ? "yes" : "no",
        leaderName: record.leaderName || "",
        leaderRelationship: record.leaderRelationship || "",
        position: record.position || "",
        isAbroad: record.isAbroad ? "yes" : "no",
        abroadName: record.abroadName || "",
        abroadRelationship: record.abroadRelationship || "",
      })) || [];

    setValue(leadershipRecord[0] || {});
  };

  const editEmployment = async () => {
    setOpenEmployment(2);

    const employmentRecord =
      info?.employementHistory?.map((record) => ({
        companyName: record.companyName || "",
        employerName: record.employerName || "",
        employerMobile: record.employerMobile || "",
        position: record.position || "",
        jobStartDate: record.startDate ? record.startDate.split("T")[0] : "", // Corrected to map startDate to jobStartDate
        jobEndDate: record.endDate ? record.endDate.split("T")[0] : "", // Corrected to map endDate to jobEndDate
      })) || [];

    setValue({ employementRecords: employmentRecord });
  };

  const editDiaspora = async () => {
    setOpenDiaspora(2);
    const diasporaRecord = info?.diasporaDetails[0] || {};
    const diasporaData = {
      livedAbroad: diasporaRecord.livedAbroad ? 1 : 0,
      isParent: diasporaRecord.isParent ? 1 : 0,
      country: diasporaRecord.country || "",
      address: diasporaRecord.address || "",
    };
    setValue(diasporaData);
  };

  const editParents = async () => {
    const parent = info?.parents?.[0] || {};


    setOpenParents(2);

    setValue0("fatherName", parent.fatherName || "");
    setValue0("motherName", parent.motherName || "");

    setValue0("fatherProvince", parent.fatherProvince || "");
    setValue0("fatherDistrict", parent.fatherDistrict || "");
    setValue0("fatherSector", parent.fatherSector || "");
    setValue0("fatherCell", parent.fatherCell || "");
    setValue0("fatherVillage", parent.fatherVillage || "");
    setValue0(
      "fatherVillageLeaderMobile",
      parent.fatherVillageLeaderMobile || ""
    );
    setValue0("fatherVillageLeaderName", parent.fatherVillageLeaderName || "");
    setValue0("fatherHouseNo", parent.fatherHouseNo || "");
    setValue0("fatherStreet", parent.fatherStreet || "");
    setValue0("fatherOccupation", parent.fatherOccupation || "");

    setValue0("motherProvince", parent.motherProvince || "");
    setValue0("motherDistrict", parent.motherDistrict || "");
    setValue0("motherSector", parent.motherSector || "");
    setValue0("motherCell", parent.motherCell || "");
    setValue0("motherVillage", parent.motherVillage || "");
    setValue0(
      "motherVillageLeaderMobile",
      parent.motherVillageLeaderMobile || ""
    );
    setValue0("motherVillageLeaderName", parent.motherVillageLeaderName || "");
    setValue0("motherHouseNo", parent.motherHouseNo || "");
    setValue0("motherStreet", parent.motherStreet || "");
    setValue0("motherOccupation", parent.motherOccupation || "");

    setValue0("parentsPlaceOfOrigin", parent.parentsPlaceOfOrigin || "");
  };

  const editCivilStatus = async () => {
    setOpenCivilStatus(2);
    const civilStatus = info?.civilStatus?.[0] || {};
    setValue0("fatherInLawCell", civilStatus.fatherInLawCell || "");
    setValue0("fatherInLawDistrict", civilStatus.fatherInLawDistrict || "");
    setValue0("fatherInLawHouseNo", civilStatus.fatherInLawHouseNo || "");
    setValue0("fatherInLawName", civilStatus.fatherInLawName || "");
    setValue0("fatherInLawProvince", civilStatus.fatherInLawProvince || "");
    setValue0("fatherInLawSector", civilStatus.fatherInLawSector || "");
    setValue0("fatherInLawStreet", civilStatus.fatherInLawStreet || "");
    setValue0("fatherInLawVillage", civilStatus.fatherInLawVillage || "");
    setValue0(
      "fatherInLawVillageLeaderMobile",
      civilStatus.fatherInLawVillageLeaderMobile || ""
    );
    setValue0(
      "fatherInLawVillageLeaderName",
      civilStatus.fatherInLawVillageLeaderName || ""
    );
    setValue0("motherInLawCell", civilStatus.motherInLawCell || "");
    setValue0("motherInLawDistrict", civilStatus.motherInLawDistrict || "");
    setValue0("motherInLawHouseNo", civilStatus.motherInLawHouseNo || "");
    setValue0("motherInLawName", civilStatus.motherInLawName || "");
    setValue0("motherInLawProvince", civilStatus.motherInLawProvince || "");
    setValue0("motherInLawSector", civilStatus.motherInLawSector || "");
    setValue0("motherInLawStreet", civilStatus.motherInLawStreet || "");
    setValue0("motherInLawVillage", civilStatus.motherInLawVillage || "");
    setValue0(
      "motherInLawVillageLeaderMobile",
      civilStatus.motherInLawVillageLeaderMobile || ""
    );
    setValue0(
      "motherInLawVillageLeaderName",
      civilStatus.motherInLawVillageLeaderName || ""
    );
    setValue0("spouseName", civilStatus.spouseName || "");
    setValue0("isMarried", civilStatus.isMarried ? 1 : 0);
  };

  const onSuccess = (resp) => {
    if (resp?.status) {
      setLoading(false);
      loadData().then();
      history.push(`/admin/profile/${id}`);
    }
  };
  useEffect(() => {}, [valueTab]);

  return (loading && !info) || error || !info ? (
    <PageLoading error={loading ? null : error} onRefresh={loadData} />
  ) : (
    <div className="flex flex-wrap">
      <div className="w-full px-2 sm:px-4">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg border-0">
          <div ref={printRef}>
            <div className="rounded bg-white mb-0 px-0 py-0 overflow-hidden">
              <div className="w-full flex gap-2 md:flex-row flex-col items-center p-4 sm:p-6 md:p-8">
                <Card
                  style={{
                    marginBottom: "20px",
                    padding: "clamp(12px, 4vw, 20px)",
                    width: "100%",
                    border: "0px #fff",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "8px",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: "bold",
                      }}
                    >
                      Employee Details
                    </Typography>

                    {false && (
                      <PDFGenerator contentRef={printRef} />
                    )}
                  </div>
                  {loading || !info ? (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="body1" style={{ margin: 10 }}>
                          <PageLoading error={null} />
                        </Typography>
                      </Grid>
                    </>
                  ) : (
                    <div ref={printRef}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={7}>
                          <Card
                            style={{
                              padding: "clamp(12px, 4vw, 20px)",
                              height: "100%",
                              border: "1px solid #E0E0E0",
                              borderRadius: "8px",
                            }}
                          >


                            <Typography
                              // variant="h6"
                              sx={{ backgroundColor: mainBackground, color: "#fff" }}
                              style={{
                                borderRadius: "8px",
                                padding: "clamp(12px, 4vw, 20px)",
                                marginBottom: "10px",
                                fontWeight: "bold",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "8px",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              Personal Details
                              {(isMe || CheckHasAnyPermission(
                                changeEmpDetails,
                                "read"
                              )) && (
                                  <Button
                                    onClick={() => {
                                      editProfile();
                                    }}
                                    size={"small"}
                                    // variant={""}
                                    style={{
                                      backgroundColor: mainBackground,
                                      color: "#fff",
                                    }}
                                    startIcon={<BsPencil />}
                                  >
                                    Edit
                                  </Button>
                                )}
                            </Typography>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={12} sm={4} md={3} sx={{ textAlign: { xs: "center", sm: "left" }, paddingRight: { xs: 0, sm: "10px" } }}>
                                <div className={`${classes.profile}`}>
                                  {info?.resource?.profile ? (
                                    <OpenDocuments
                                      planeImage={true}
                                      imgClassName={`${classes.image} shadow-xl align-middle border-5 max-w-130-px rounded-md `}
                                      document={info?.resource?.profile}
                                      mimeType={getFileMime(
                                        info?.resource?.profile
                                      )}
                                      name={info?.resource?.profile}
                                      specialName={info?.resource?.profile}
                                    />
                                  ) : (
                                    <img
                                      className={`${classes.image} shadow-xl align-middle max-w-120-px`}
                                      alt={`${info?.resource?.names}`}
                                      src={require("assets/img/team-2-800x800.png")}
                                      style={{
                                        display: "block",
                                        width: "120px",
                                        height: "120px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        margin: "auto",
                                      }}
                                    />

                                  )}

                                  <div className={`${classes.middle}`}
                                    style={{
                                      display: "block",
                                      width: "120px",
                                      height: "120px",
                                      objectFit: "cover",
                                      borderRadius: "8px",


                                    }}

                                  >
                                    {(isMe || CheckHasAnyPermission(
                                      changeEmpDetails,
                                      "read"
                                    )) && (

                                        <Button onClick={handleClick} className="rounded-full">
                                          <i className="fa fa-cloud-upload-alt text-slate-50 p-4 fa-4x" />
                                        </Button>
                                      )}
                                    <input
                                      style={{ display: "none" }}
                                      ref={inputRef}
                                      type={"file"}
                                      accept="image/*"
                                      onChange={(e) => {
                                        updateProfile(e.target.files);
                                        setLoading(true);
                                      }}
                                    />
                                  </div>
                                </div>
                                <span
                                  pt-3
                                  style={{ margin: "10px", display: "inline-flex", alignItems: "center", gap: "4px" }}
                                >
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "8px",
                                      height: "8px",
                                      borderRadius: "50%",
                                      marginLeft: "20px",
                                      backgroundColor: (() => {
                                        switch (info?.resource?.status) {
                                          case "active":
                                          case "completed":
                                          case "paid":
                                            return "#4CAF50"; // Green
                                          case "quit":
                                          case "canceled":
                                          case "overdue":
                                          case "deleted":
                                          case "denied":
                                          case "departed":
                                            return "#8B0000"; // Red
                                          // case "not yet started":
                                          case "in progress":
                                          case "in-progress":
                                          case "on-leave":
                                            return "#FFA400"; // Orange
                                          case "to-do":
                                            return "#3895D3"; // Blue
                                          case "incoming":
                                          case "upcoming":
                                            return "#ADD8E6"; // Light Blue
                                          default:
                                            return "#D3D3D3"; // Default Gray
                                        }
                                      })(),
                                    }}
                                  ></span>
                                  <span>{`${info?.resource?.status === 'quit' ? 'Departed' : info?.resource?.status}`}</span>
                                </span>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Grid container spacing={2} >
                                  {[
                                    {
                                      label: "First Name:",
                                      value: info?.resource?.names ? info.resource.names.split(" ")[0] : "N/A",
                                    },
                                    {
                                      label: "Last Name:",
                                      value: info?.resource?.names
                                        ? info.resource.names.split(" ").slice(1).join(" ") || "N/A"
                                        : "N/A",
                                    },
                                    {
                                      label: "Phone Number:",
                                      value: info?.resource?.phone || "N/A",
                                    },
                                    {
                                      label: "Email:",
                                      value: info?.resource?.email || "N/A",
                                    },
                                    {
                                      label: "Entry Date:",
                                      value: info?.resource?.entryDate
                                        ? moment(info?.resource?.entryDate).format("YYYY-MM-DD")
                                        : "N/A",
                                    },

                                    // {
                                    //   label: "Structure",
                                    //   value: info?.resource?.structureName || "N/A",
                                    // },
                                    {
                                      label: info?.resource?.structureCategory + ":",
                                      value:
                                        info?.resource?.structureName || "N/A",
                                    },
                                    {
                                      label: "Position:",
                                      value: info?.resource?.positionName || "N/A",
                                    },
                                  ].map((item, index) => (
                                    <Grid
                                      item
                                      xs={12}
                                      key={index}
                                      container
                                      style={{ margin: "10px", fontSize: "12px" }}
                                    >
                                      <Grid
                                        item
                                        xs={5}
                                        style={{
                                          color: "#757575",
                                          fontWeight: "normal", fontSize: "12px",
                                        }}
                                      >
                                        {item.label}
                                      </Grid>
                                      <Grid
                                        item
                                        xs={7}
                                        style={{ fontWeight: "bold", fontSize: "12px" }}
                                      >
                                        {item.value}
                                      </Grid>
                                    </Grid>
                                  ))}
                                </Grid>
                              </Grid>
                            </Grid>
                          </Card>
                        </Grid>

                        {false && (
                          <Grid item xs={12} md={3.5}>

                            <Card
                              style={{
                                padding: "20px",
                                height: "100%",
                                border: "1px solid #E0E0E0",
                                borderRadius: "8px",
                              }}
                            >

                              <Typography
                                // variant="h6"
                                sx={{ backgroundColor: mainBackground, color: "#fff" }}
                                style={{
                                  borderRadius: "8px",
                                  padding: "20px",
                                  marginBottom: "10px",
                                  fontWeight: "bold",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <span>Current Residence</span>
                                <Button
                                  onClick={() => {
                                    editCurrentResidence();
                                  }}
                                  size={"small"}
                                  // variant={""}
                                  style={{
                                    backgroundColor: mainBackground,
                                    color: "#fff",
                                  }}
                                  startIcon={<BsPencil />}
                                >
                                  Edit
                                </Button>
                              </Typography>

                              <Grid container spacing={1} >
                                {[
                                  {
                                    label: "Province:",
                                    value: info?.resource?.province || "N/A",
                                  },
                                  {
                                    label: "District:",
                                    value: info?.resource?.district || "N/A",
                                  },
                                  {
                                    label: "Sector:",
                                    value: info?.resource?.sector || "N/A",
                                  },
                                  {
                                    label: "Village:",
                                    value: info?.resource?.village || "N/A",
                                  },
                                  {
                                    label: "House No:",
                                    value: info?.resource?.houseNo || "N/A",
                                  },
                                  {
                                    label: "Village Leader Name:",
                                    value:
                                      info?.resource?.villageLeaderName || "N/A",
                                  },
                                  {
                                    label: "Village Leader Contact:",
                                    value:
                                      info?.resource?.villageLeaderMobile || "N/A",
                                  },
                                ].map((item, index) => (
                                  <Grid
                                    item
                                    xs={12}
                                    key={index}
                                    container
                                    style={{ margin: "10px", fontSize: "12px" }}
                                  >
                                    <Grid
                                      item
                                      xs={5}
                                      style={{
                                        color: "#757575",
                                        fontWeight: "normal", fontSize: "12px",
                                      }}
                                    >
                                      {item.label}
                                    </Grid>
                                    <Grid
                                      item
                                      xs={7}
                                      style={{ fontWeight: "bold", fontSize: "12px" }}
                                    >
                                      {item.value}
                                    </Grid>
                                  </Grid>
                                ))}
                              </Grid>
                            </Card>
                          </Grid>

                        )}
                        <Grid item xs={12} md={5}>
                          <Card
                            style={{
                              padding: "clamp(12px, 4vw, 20px)",
                              height: "100%",
                              border: "1px solid #E0E0E0",
                              borderRadius: "8px",
                            }}
                          >
                            <Typography
                              // variant="h6"
                              sx={{ backgroundColor: mainBackground, color: "#fff" }}
                              style={{
                                borderRadius: "8px",
                                padding: "clamp(12px, 4vw, 20px)",
                                marginBottom: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              Reporting Line
                            </Typography>
                            <Grid container spacing={1} >
                              {info?.myLineManagers?.map((manager, index) => {
                                // console.log("Manager:", manager);

                                return (
                                  <Grid container spacing={1} key={index} style={{ marginBottom: "20px" }}>

                                    {[
                                      {
                                        label: "Line manager"
                                      },
                                      {
                                        label: "Name:",
                                        value: manager.names || "N/A",
                                      },
                                      {
                                        label: "Position:",
                                        value: manager.positionName || "N/A",
                                      },
                                      {
                                        label: manager.structureCategory + ":" || "Structure",
                                        value: manager.structureName || "N/A",
                                      },
                                    ].map((item, idx) => (
                                      <Grid item xs={12} key={idx} container
                                        style={{ margin: "10px", fontSize: "12px" }}>

                                        <Grid item xs={4} style={{ color: "#757575", fontWeight: "normal", fontSize: "12px" }}>
                                          {item.label}
                                        </Grid>
                                        <Grid item xs={7} style={{ fontWeight: "bold", fontSize: "12px" }}>
                                          {item.value}
                                        </Grid>
                                      </Grid>
                                    ))}
                                  </Grid>
                                );
                              })}
                            </Grid>
                          </Card>
                        </Grid>

                        {false && (
                          <Grid item xs={12}>
                            <Card
                              style={{
                                padding: "20px",
                                border: "1px solid #E0E0E0",
                                borderRadius: "8px",
                              }}
                            >
                              <CollapsibleDetailsSection title="Other Details" mainBackground={mainBackground}>
                                <Grid container spacing={2} ref={printRef}>
                                  <Grid item xs={12} md={4}>

                                    <Grid container spacing={1} alignItems="center">
                                      <Grid item xs={5} style={{ fontWeight: "normal" }}>
                                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', fontSize: "12px" }}>
                                          PARENT DETAILS
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Button
                                          onClick={() => {
                                            editParents();
                                          }}
                                          size={"small"}
                                          sx={{ color: mainBackground, minWidth: 0, padding: 0 }}
                                          startIcon={<BsPencil />}
                                        />
                                      </Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                      {info?.parents?.length > 0 ? (
                                        info.parents.map((parent, index) => (
                                          <React.Fragment key={parent.id}>
                                            {/* Father's Details Section */}
                                            <Typography
                                              // variant="h3"
                                              style={{
                                                fontWeight: "bold",
                                                marginBottom: "10px",
                                                marginTop: "10px",
                                                color: mainBackground,
                                                fontSize: "13px",
                                                marginLeft: "10px",
                                              }}
                                            >
                                              Father's Details
                                            </Typography>
                                            {[
                                              {
                                                label: "Father's Name:",
                                                value: parent.fatherName || "N/A",
                                              },
                                              {
                                                label: "Father's Occupation:",
                                                value:
                                                  parent.fatherOccupation ||
                                                  "N/A",
                                              },
                                              {
                                                label: "Father's Province:",
                                                value:
                                                  parent.fatherProvince || "N/A",
                                              },
                                              {
                                                label: "Father's District:",
                                                value:
                                                  parent.fatherDistrict || "N/A",
                                              },
                                              {
                                                label: "Father's Sector:",
                                                value:
                                                  parent.fatherSector || "N/A",
                                              },
                                              {
                                                label: "Father's Village:",
                                                value:
                                                  parent.fatherVillage || "N/A",
                                              },
                                              {
                                                label:
                                                  "Father's Village Leader Name:",
                                                value:
                                                  parent.fatherVillageLeaderName ||
                                                  "N/A",
                                              },
                                              {
                                                label:
                                                  "Father's Village Leader Contact:",
                                                value:
                                                  parent.fatherVillageLeaderMobile ||
                                                  "N/A",
                                              },
                                              {
                                                label: "Father's Street:",
                                                value:
                                                  parent.fatherStreet || "N/A",
                                              },
                                              {
                                                label: "Father's HouseNumber:",
                                                value:
                                                  parent.fatherHouseNo || "N/A",
                                              },
                                            ].map((item, idx) => (
                                              <Grid
                                                item
                                                xs={12}
                                                key={idx}
                                                container
                                              >
                                                <Grid
                                                  item
                                                  xs={5}
                                                  style={{
                                                    color: "#757575",
                                                    fontWeight: "normal", fontSize: "12px",
                                                  }}
                                                >
                                                  {item.label}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={7}
                                                  style={{ fontWeight: "bold", fontSize: "12px" }}
                                                >
                                                  {item.value}
                                                </Grid>
                                              </Grid>
                                            ))}

                                            <Box mt={3} />

                                            <Typography
                                              // variant="h3"
                                              style={{
                                                fontWeight: "bold",
                                                marginBottom: "10px",
                                                marginTop: "10px",
                                                color: mainBackground,
                                                fontSize: "13px",
                                                marginLeft: "10px",
                                              }}
                                            >
                                              Mother's Details
                                            </Typography>
                                            {[
                                              {
                                                label: "Mother's Name:",
                                                value: parent.motherName || "N/A",
                                              },
                                              {
                                                label: "Mother's Occupation:",
                                                value:
                                                  parent.motherOccupation ||
                                                  "N/A",
                                              },
                                              {
                                                label: "Mother's Province:",
                                                value:
                                                  parent.motherProvince || "N/A",
                                              },
                                              {
                                                label: "Mother's District:",
                                                value:
                                                  parent.motherDistrict || "N/A",
                                              },
                                              {
                                                label: "Mother's Sector:",
                                                value:
                                                  parent.motherSector || "N/A",
                                              },
                                              {
                                                label: "Mother's Village:",
                                                value:
                                                  parent.motherVillage || "N/A",
                                              },
                                              {
                                                label:
                                                  "Mother's Village Leader Name:",
                                                value:
                                                  parent.motherVillageLeaderName ||
                                                  "N/A",
                                              },
                                              {
                                                label:
                                                  "Mother's Village Leader Contact:",
                                                value:
                                                  parent.motherVillageLeaderMobile ||
                                                  "N/A",
                                              },
                                              {
                                                label: "Mother's Street:",
                                                value:
                                                  parent.motherStreet || "N/A",
                                              },
                                              {
                                                label: "Mother's HouseNumber:",
                                                value:
                                                  parent.motherHouseNo || "N/A",
                                              },
                                              {
                                                label: "Parents place of Origin:",
                                                value:
                                                  parent.parentsPlaceOfOrigin ||
                                                  "N/A",
                                              },
                                            ].map((item, idx) => (
                                              <Grid
                                                item
                                                xs={12}
                                                key={idx}
                                                container
                                              >
                                                <Grid
                                                  item
                                                  xs={5}
                                                  style={{
                                                    color: "#757575",
                                                    fontWeight: "normal", fontSize: "12px",
                                                  }}
                                                >
                                                  {item.label}
                                                </Grid>
                                                <Grid
                                                  item
                                                  xs={7}
                                                  style={{ fontWeight: "bold", fontSize: "12px" }}
                                                >
                                                  {item.value}
                                                </Grid>
                                              </Grid>
                                            ))}
                                          </React.Fragment>
                                        ))
                                      ) : (
                                        <Typography variant="body1" style={{ marginLeft: 10, color: "#757575", fontSize: "12px" }}>
                                          No parent details available.
                                        </Typography>
                                      )}
                                    </Grid>

                                    <Grid
                                      mt={5}
                                      container
                                      spacing={1}
                                    >

                                      <Grid
                                        item
                                        xs={5}
                                        style={{ fontWeight: "normal", fontSize: "12px" }}
                                      >
                                        <Typography
                                          variant="subtitle1"
                                          gutterBottom
                                          sx={{ fontWeight: "bold", fontSize: "12px" }}
                                        >
                                          EDUCATION RECORD
                                        </Typography>
                                      </Grid>
                                      <Grid item>
                                        <Button
                                          onClick={() => {
                                            editEducation();
                                          }}
                                          size={"small"}
                                          sx={{ color: mainBackground, minWidth: 0, padding: 0 }}
                                          startIcon={<BsPencil />}
                                        />
                                      </Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                      {info?.educationHistory?.length > 0 ? (
                                        info.educationHistory.map(
                                          (education, index) => (
                                            <Grid
                                              item
                                              xs={12}
                                              key={education.id}
                                              style={{ marginBottom: "20px" }}
                                            >
                                              <Typography
                                                // variant="h3"
                                                style={{
                                                  fontWeight: "bold",
                                                  marginBottom: "10px",
                                                  fontSize: "13px",
                                                  color: mainBackground,
                                                }}
                                              >
                                                Education Record {index + 1}
                                              </Typography>
                                              <Grid
                                                container
                                                spacing={1}>

                                                {[
                                                  {
                                                    label: "Education institution",
                                                    value:
                                                      education.institution ||
                                                      "N/A",
                                                  },
                                                  {
                                                    label: "Location:",
                                                    value:
                                                      education.location || "N/A",
                                                  },
                                                  {
                                                    label: `Degree & Diploma:`,
                                                    value:
                                                      education.degreeDiploma ||
                                                      "N/A",
                                                  },
                                                  {
                                                    label: "Major Of Study:",
                                                    value:
                                                      education.fieldOfStudy ||
                                                      "N/A",
                                                  },
                                                  {
                                                    label: "Class of Degree:",
                                                    value:
                                                      education.classOfDegree ||
                                                      "N/A",
                                                  },
                                                  {
                                                    label: "Start Date:",
                                                    value: education.startYear
                                                      ? moment(
                                                        education.startYear
                                                      ).format("DD-MM-YYYY")
                                                      : "N/A",
                                                  },
                                                  {
                                                    label: "End Date:",
                                                    value: education.endYear
                                                      ? moment(
                                                        education.endYear
                                                      ).format("DD-MM-YYYY")
                                                      : "N/A",
                                                  },
                                                ].map((item, idx) => (
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    key={idx}
                                                    container
                                                  >
                                                    <Grid
                                                      item
                                                      xs={5}
                                                      style={{
                                                        color: "#757575",
                                                        fontWeight: "normal", fontSize: "12px",
                                                      }}
                                                    >
                                                      {item.label}
                                                    </Grid>
                                                    <Grid
                                                      item
                                                      xs={7}
                                                      style={{ fontWeight: "bold", fontSize: "12px" }}
                                                    >
                                                      {item.value}
                                                    </Grid>
                                                  </Grid>
                                                ))}
                                              </Grid>
                                            </Grid>
                                          )
                                        )
                                      ) : (
                                        <Typography variant="body1" style={{ marginTop: 5, marginLeft: 15, color: "#757575" }}>
                                          No education details available.
                                        </Typography>
                                      )}
                                    </Grid>


                                    <Grid mt={5} container spacing={1} alignItems="center">
                                      <Grid item xs={5} style={{ fontWeight: "normal" }}>
                                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', fontSize: "12px" }}>
                                          REFERENCE DETAILS
                                        </Typography>
                                      </Grid>
                                      <Grid item sx={{ mt: -1, ml: 1 }}>
                                        <Button
                                          onClick={() => {
                                            editReferences();
                                          }}
                                          size={"small"}
                                          sx={{ color: mainBackground, minWidth: 0, padding: 0 }}
                                          startIcon={<BsPencil />}
                                        />
                                      </Grid>
                                    </Grid>

                                    <Grid container spacing={1}>
                                      {info?.references?.length > 0 ? (
                                        info.references.map(
                                          (reference, index) => (
                                            <Grid
                                              item
                                              xs={12}
                                              key={reference.id}
                                              style={{ marginBottom: "20px" }}
                                            >
                                              <Typography
                                                // variant="h3"
                                                style={{
                                                  fontWeight: "bold",
                                                  marginBottom: "10px",
                                                  fontSize: "12px",

                                                  color: mainBackground,
                                                }}
                                              >
                                                Reference Record {index + 1}
                                              </Typography>
                                              <Grid
                                                container
                                                spacing={1}
                                              >
                                                {[
                                                  {
                                                    label: "Reference Name:",
                                                    value: reference.name || "N/A",
                                                  },
                                                  {
                                                    label: "Reference Address:",
                                                    value:
                                                      reference.address || "N/A",
                                                  },
                                                  {
                                                    label: "Reference Type:",
                                                    value:
                                                      reference.relationship ===
                                                        "other"
                                                        ? reference.customRelationship ||
                                                        "N/A"
                                                        : reference.relationship ||
                                                        "N/A",
                                                  },
                                                  {
                                                    label: "Reference Phone:",
                                                    value:
                                                      reference.mobileNumber ||
                                                      "N/A",
                                                  },
                                                ].map((item, idx) => (
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    key={idx}
                                                    container
                                                  >
                                                    <Grid
                                                      item
                                                      xs={5}
                                                      style={{
                                                        color: "#757575",
                                                        fontWeight: "normal", fontSize: "12px",
                                                      }}
                                                    >
                                                      {item.label}
                                                    </Grid>
                                                    <Grid
                                                      item
                                                      xs={7}
                                                      style={{ fontWeight: "bold", fontSize: "12px" }}
                                                    >
                                                      {item.value}
                                                    </Grid>
                                                  </Grid>
                                                ))}
                                              </Grid>
                                            </Grid>
                                          )
                                        )
                                      ) : (
                                        <Typography variant="body1" style={{ marginTop: 5, marginLeft: 15, color: "#757575" }}>
                                          No reference details available.
                                        </Typography>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Grid
                                      container
                                      spacing={1}
                                      alignItems="center"
                                    >
                                      <Grid
                                        item
                                        xs={5}
                                        style={{ fontWeight: "normal", fontSize: "12px" }}
                                      >
                                        <Typography
                                          variant="subtitle1"
                                          gutterBottom
                                          sx={{ fontWeight: "bold", fontSize: "12px" }}
                                        >
                                          DIASPORA DETAILS
                                        </Typography>
                                      </Grid>
                                      <Grid item sx={{ mt: -1, ml: 0 }}>
                                        <Button
                                          onClick={() => {
                                            editDiaspora();
                                          }}
                                          size={"small"}
                                          sx={{ color: mainBackground, minWidth: 0, padding: 0 }}
                                          startIcon={<BsPencil />}
                                        />
                                      </Grid>
                                    </Grid>

                                    <Grid container spacing={1}>
                                      {info?.diasporaDetails?.length > 0 ? (
                                        info.diasporaDetails.map(
                                          (diaspora, index) => (
                                            <React.Fragment key={diaspora.id}>
                                              <Typography
                                                variant="h6"
                                                style={{
                                                  fontWeight: "bold",
                                                  marginBottom: "10px",
                                                  color: mainBackground,
                                                }}
                                              ></Typography>
                                              {[
                                                {
                                                  label: "Have you or your Parent lived abroad?",
                                                  value: diaspora.livedAbroad
                                                    ? "Yes"
                                                    : "No",
                                                },
                                                ...(diaspora.country
                                                  ? [
                                                    {
                                                      label: "Country:",
                                                      value: diaspora.country,
                                                    },
                                                  ]
                                                  : []),
                                                ...(diaspora.address
                                                  ? [
                                                    {
                                                      label: "Address:",
                                                      value: diaspora.address,
                                                    },
                                                  ]
                                                  : []),
                                                ...(diaspora.livedAbroad
                                                  ? [
                                                    {
                                                      label:
                                                        "Who lived abroad?",
                                                      value: diaspora.isParent
                                                        ? "Parents"
                                                        : "Me",
                                                    },
                                                  ]
                                                  : []),
                                              ].map((item, idx) => (
                                                <Grid
                                                  item
                                                  xs={12}
                                                  key={idx}
                                                  container
                                                >
                                                  <Grid
                                                    item
                                                    xs={5}
                                                    style={{
                                                      color: "#757575",
                                                      fontWeight: "normal", fontSize: "12px",
                                                    }}
                                                  >
                                                    {item.label}
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={7}
                                                    style={{ fontWeight: "bold", fontSize: "12px" }}
                                                  >
                                                    {item.value}
                                                  </Grid>
                                                </Grid>
                                              ))}
                                            </React.Fragment>
                                          ))
                                      ) : (
                                        <Typography variant="body1" style={{ marginLeft: 10, color: "#757575" }}>
                                          No diaspora details available.
                                        </Typography>
                                      )}
                                    </Grid>

                                    <Grid item xs={12}>
                                      <Grid
                                        mt={5}
                                        container
                                        spacing={1}
                                        alignItems="center"
                                      >
                                        <Grid
                                          item
                                          xs={12}
                                          style={{ fontWeight: "normal", fontSize: "12px" }}
                                        >
                                          <Typography
                                            variant="subtitle1"
                                            gutterBottom
                                            sx={{ fontWeight: "bold", fontSize: "12px" }}
                                          >
                                            EMPLOYEMENT HISTORY
                                            <Button
                                              onClick={() => {
                                                editEmployment();
                                              }}
                                              size={"small"}
                                              sx={{ color: mainBackground, minWidth: 0, padding: 0, ml: 1 }}
                                              startIcon={<BsPencil />}
                                            />
                                          </Typography>
                                        </Grid>
                                      </Grid>

                                      <Grid container spacing={1}>
                                        {info?.employementHistory?.length > 0 ? (
                                          info.employementHistory.map(
                                            (employement, index) => (
                                              <Grid
                                                item
                                                xs={12}
                                                key={employement.id}
                                                style={{ marginBottom: "20px" }}
                                              >
                                                <Typography
                                                  // variant="h3"
                                                  style={{
                                                    fontWeight: "bold",
                                                    marginBottom: "10px",
                                                    fontSize: "13px",
                                                    color: mainBackground,
                                                  }}
                                                >
                                                  Employment Record {index + 1}
                                                </Typography>
                                                <Grid
                                                  container
                                                  spacing={1}
                                                >
                                                  {[
                                                    {
                                                      label: "Company Name:",
                                                      value:
                                                        employement.companyName ||
                                                        "N/A",
                                                    },
                                                    {
                                                      label: "Employer Name:",
                                                      value:
                                                        employement.employerName ||
                                                        "N/A",
                                                    },
                                                    {
                                                      label: "Employer Mobile:",
                                                      value:
                                                        employement.employerMobile ||
                                                        "N/A",
                                                    },
                                                    {
                                                      label: "Position:",
                                                      value:
                                                        employement.position ||
                                                        "N/A",
                                                    },
                                                    {
                                                      label: "Started At:",
                                                      value: employement.startDate
                                                        ? moment(
                                                          employement.startDate
                                                        ).format("DD-MM-YYYY")
                                                        : "N/A",
                                                    },
                                                    {
                                                      label: "End Date:",
                                                      value: employement.endDate
                                                        ? moment(
                                                          employement.endDate
                                                        ).format("DD-MM-YYYY")
                                                        : "N/A",
                                                    },
                                                  ].map((item, idx) => (
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      key={idx}
                                                      container
                                                    >
                                                      <Grid
                                                        item
                                                        xs={5}
                                                        style={{
                                                          color: "#757575",
                                                          fontWeight: "normal", fontSize: "12px",
                                                        }}
                                                      >
                                                        {item.label}
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={7}
                                                        style={{
                                                          fontWeight: "bold", fontSize: "12px"
                                                        }}
                                                      >
                                                        {item.value}
                                                      </Grid>
                                                    </Grid>
                                                  ))}
                                                </Grid>
                                              </Grid>
                                            )
                                          )
                                        ) : (
                                          <Typography variant="body1" style={{ marginTop: 5, marginLeft: 15, color: "#757575" }}>
                                            No employment details available.
                                          </Typography>
                                        )}
                                      </Grid>
                                      <Grid
                                        mt={5}
                                        container
                                        spacing={1}
                                        alignItems="center"
                                      >
                                        <Grid
                                          item
                                          xs={12}
                                          style={{ fontWeight: "normal", fontSize: "12px" }}
                                        >
                                          <Typography
                                            variant="subtitle1"
                                            gutterBottom
                                            sx={{ fontWeight: "bold", fontSize: "12px" }}
                                          >
                                            LEADERSHIP DETAILS
                                            <Button
                                              onClick={() => {
                                                editLeadership();
                                              }}
                                              size={"small"}
                                              sx={{ color: mainBackground, minWidth: 0, padding: 0, ml: 1 }}
                                              startIcon={<BsPencil />}
                                            />
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      <Grid container spacing={1}>
                                        {info?.leadership?.length > 0 ? (
                                          info.leadership.map(
                                            (leadership, index) => (
                                              <React.Fragment key={leadership.id}>
                                                <Typography
                                                  variant="h6"
                                                  style={{
                                                    fontWeight: "bold",
                                                    marginBottom: "10px",
                                                    color: mainBackground,
                                                  }}
                                                ></Typography>
                                                {[
                                                  {
                                                    label:
                                                      "Relative in Leadership",
                                                    value: leadership.isLeader
                                                      ? "Yes"
                                                      : "No",
                                                  },
                                                  {
                                                    label: "His/Her Names:",
                                                    value:
                                                      leadership.leaderName ||
                                                      "N/A",
                                                  },
                                                  {
                                                    label: "Relationship:",
                                                    value:
                                                      leadership.leaderRelationship ||
                                                      "N/A",
                                                  },
                                                  {
                                                    label: "Position:",
                                                    value:
                                                      leadership.position ||
                                                      "N/A",
                                                  },
                                                  {
                                                    label:
                                                      "Relative who's Abroad:",
                                                    value: leadership.isAbroad
                                                      ? "Yes"
                                                      : "No",
                                                  },
                                                  {
                                                    ...(leadership?.abroadName
                                                      ? {
                                                        label: "his/her Name:",
                                                        value:
                                                          leadership.abroadName,
                                                      }
                                                      : {}),
                                                  },
                                                  {
                                                    ...(leadership?.abroadRelationship
                                                      ? {
                                                        label: "Relationship:",
                                                        value:
                                                          leadership.abroadRelationship,
                                                      }
                                                      : {}),
                                                  },
                                                ].map((item, idx) => (
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    key={idx}
                                                    container
                                                  >
                                                    <Grid
                                                      item
                                                      xs={5}
                                                      style={{
                                                        color: "#757575",
                                                        fontWeight: "normal", fontSize: "12px",
                                                      }}
                                                    >
                                                      {item.label}
                                                    </Grid>
                                                    <Grid
                                                      item
                                                      xs={7}
                                                      style={{
                                                        fontWeight: "bold",
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      {item.value}
                                                    </Grid>
                                                  </Grid>
                                                ))}
                                              </React.Fragment>
                                            ))
                                        ) : (
                                          <Typography variant="body1" style={{ marginTop: 5, marginLeft: 10, color: "#757575" }}>
                                            No diaspora details available.
                                          </Typography>
                                        )}
                                      </Grid>

                                      <Grid
                                        mt={5}
                                        container
                                        spacing={1}
                                        alignItems="center"
                                      >
                                        <Grid
                                          item
                                          xs={5}
                                          style={{ fontWeight: "normal", fontSize: "12px" }}
                                        >
                                          <Typography
                                            variant="subtitle1"
                                            gutterBottom
                                            sx={{ fontWeight: "bold", fontSize: "12px" }}
                                          >
                                            Civil Status
                                          </Typography>
                                        </Grid>

                                        <Grid item sx={{ mt: -1 }}>
                                          <Button
                                            onClick={() => {
                                              editCivilStatus();
                                            }}
                                            size={"small"}
                                            sx={{ color: mainBackground, minWidth: 0, padding: 0 }}
                                            startIcon={<BsPencil />}
                                          />
                                        </Grid>
                                      </Grid>
                                      <Grid container spacing={1}>
                                        {info?.civilStatus?.length > 0 ? (
                                          info.civilStatus.map((civil, index) => {
                                            // Check if there is any valid data to display
                                            const hasData =
                                              civil.spouseName ||
                                              civil.fatherInLawName ||
                                              civil.motherInLawName;

                                            return hasData ? (
                                              <React.Fragment key={civil.id}>

                                                {[
                                                  // { label: "Is Married:", value: civil.isMarried ? "Yes" : "No" },
                                                  { label: "Spouse Name:", value: civil.spouseName || "N/A" },
                                                  { label: "Father-in-Law Name:", value: civil.fatherInLawName || "N/A" },
                                                  { label: "Father-in-Law Province:", value: civil.fatherInLawProvince || "N/A" },
                                                  { label: "Father-in-Law District:", value: civil.fatherInLawDistrict || "N/A" },
                                                  { label: "Father-in-Law Sector:", value: civil.fatherInLawSector || "N/A" },
                                                  { label: "Father-in-Law Village:", value: civil.fatherInLawVillage || "N/A" },
                                                  { label: "Father-in-Law House No:", value: civil.fatherInLawHouseNo || "N/A" },
                                                  { label: "Father-in-Law Street:", value: civil.fatherInLawStreet || "N/A" },
                                                  { label: "Father-in-Law Village Leader Name:", value: civil.fatherInLawVillageLeaderName || "N/A" },
                                                  { label: "Father-in-Law Village Leader Mobile:", value: civil.fatherInLawVillageLeaderMobile || "N/A" },
                                                  { label: "Mother-in-Law Name:", value: civil.motherInLawName || "N/A" },
                                                  { label: "Mother-in-Law Province:", value: civil.motherInLawProvince || "N/A" },
                                                  { label: "Mother-in-Law District:", value: civil.motherInLawDistrict || "N/A" },
                                                  { label: "Mother-in-Law Sector:", value: civil.motherInLawSector || "N/A" },
                                                  { label: "Mother-in-Law Village:", value: civil.motherInLawVillage || "N/A" },
                                                  { label: "Mother-in-Law House No:", value: civil.motherInLawHouseNo || "N/A" },
                                                  { label: "Mother-in-Law Street:", value: civil.motherInLawStreet || "N/A" },
                                                  { label: "Mother-in-Law Village Leader Name:", value: civil.motherInLawVillageLeaderName || "N/A" },
                                                  { label: "Mother-in-Law Village Leader Mobile:", value: civil.motherInLawVillageLeaderMobile || "N/A" },
                                                ].map((item, idx) => (
                                                  <Grid item xs={12} key={idx} container>
                                                    <Grid item xs={5} style={{ color: "#757575", fontWeight: "normal", fontSize: "12px" }}>
                                                      {item.label}
                                                    </Grid>
                                                    <Grid item xs={7} style={{ fontWeight: "bold", fontSize: "12px" }}>
                                                      {item.value}
                                                    </Grid>
                                                  </Grid>
                                                ))}
                                              </React.Fragment>
                                            ) : null; // Render nothing if no data is available
                                          })
                                        ) : (
                                          <Typography variant="body1" style={{ marginTop: 5, marginLeft: 10, color: "#757575" }}>
                                            No civil status details available.
                                          </Typography>
                                        )
                                        }
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <Grid item xs={12} md={4}>
                                    <Grid
                                      container
                                      spacing={1}
                                      alignItems="center"
                                    >
                                      <Grid
                                        item
                                        xs={12}
                                        style={{ fontWeight: "normal", fontSize: "12px" }}
                                      >
                                        <Typography
                                          variant="subtitle1"
                                          gutterBottom
                                          sx={{ fontWeight: "bold", fontSize: "12px" }}
                                        >
                                          RELATIVE DETAILS
                                          <Button
                                            onClick={() => {
                                              editRelative();
                                            }}
                                            size={"small"}
                                            sx={{ color: mainBackground, minWidth: 0, padding: 2, ml: 1 }}
                                            startIcon={<BsPencil />}
                                          />
                                        </Typography>
                                      </Grid>




                                    </Grid>


                                    <Grid container spacing={1}>
                                      {info?.family?.length > 0 ? (
                                        info.family.map((family, index) => (
                                          <Grid
                                            item
                                            xs={12}
                                            key={family.id}
                                            style={{ marginBottom: "20px" }}
                                          >
                                            <Typography
                                              // variant="h3"
                                              style={{
                                                fontWeight: "bold",
                                                marginBottom: "10px",
                                                fontSize: "13px",
                                                color: mainBackground,
                                              }}
                                            >
                                              Relative {index + 1}
                                            </Typography>
                                            <Grid
                                              container
                                              spacing={1}
                                            >
                                              {[
                                                { label: "Relation:", value: family.relationType || "N/A" },
                                                { label: "Names:", value: family.relationName || "N/A" },
                                                ...(family.country ? [{ label: "Country:", value: family.country }] : []),
                                                ...(family.placeOfWork ? [{ label: "Place of Work:", value: family.placeOfWork }] : []),
                                                ...(family.mobileNumber ? [{ label: "Mob No:", value: family.mobileNumber }] : []),

                                              ].map((item, idx) => (
                                                <Grid
                                                  item
                                                  xs={12}
                                                  key={idx}
                                                  container
                                                >
                                                  <Grid
                                                    item
                                                    xs={5}
                                                    style={{
                                                      color: "#757575",
                                                      fontWeight: "normal", fontSize: "12px",
                                                    }}
                                                  >
                                                    {item.label}
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={7}
                                                    style={{ fontWeight: "bold", fontSize: "12px" }}
                                                  >
                                                    {item.value}
                                                  </Grid>
                                                </Grid>
                                              ))}
                                            </Grid>
                                          </Grid>
                                        ))
                                      ) : (
                                        <Typography variant="body1" style={{ marginTop: 5, marginLeft: 10, color: "#757575" }}>
                                          No relative details available.
                                        </Typography>
                                      )}
                                    </Grid>

                                    <Grid item xs={12}>
                                      <Grid
                                        mt={5}
                                        container
                                        spacing={1}
                                        alignItems="center"
                                      >
                                        <Grid
                                          item
                                          xs={12}
                                          style={{ fontWeight: "normal", fontSize: "12px" }}
                                        >
                                          <Typography
                                            variant="subtitle1"
                                            gutterBottom
                                            sx={{ fontWeight: "bold", fontSize: "12px" }}
                                          >
                                            IMPRISONMENT DETAILS
                                            <Button
                                              onClick={() => {
                                                editCriminalRecord();
                                              }}
                                              size={"small"}
                                              sx={{ color: mainBackground, minWidth: 0, padding: 2, ml: 1 }}
                                              startIcon={<BsPencil />}
                                            />
                                          </Typography>
                                        </Grid>


                                      </Grid>
                                      <Grid container spacing={1}>
                                        {[
                                          {
                                            label: "Have you ever Implisoned:",
                                            value: info?.criminalRecord
                                              ?.imprisoned
                                              ? "Yes"
                                              : "No",
                                          },
                                          ...(info?.criminalRecord?.location
                                            ? [
                                              {
                                                label:
                                                  "Where have you Implisoned at:",
                                                value:
                                                  info.criminalRecord.location,
                                              },
                                            ]
                                            : []),
                                          ...(info?.criminalRecord?.reason
                                            ? [
                                              {
                                                label:
                                                  "Reason of Implisonment:",
                                                value:
                                                  info.criminalRecord.reason,
                                              },
                                            ]
                                            : []),
                                          ...(info?.criminalRecord?.startDate
                                            ? [
                                              {
                                                label: "Date of Implisonment:",
                                                value: moment(
                                                  info.criminalRecord.startDate
                                                ).format("DD-MM-YYYY"),
                                              },
                                            ]
                                            : []),
                                          ...(info?.criminalRecord?.endDate
                                            ? [
                                              {
                                                label: "Released Date:",
                                                value: moment(
                                                  info.criminalRecord.endDate
                                                ).format("DD-MM-YYYY"),
                                              },
                                            ]
                                            : []),
                                          ...(info?.criminalRecord?.duration
                                            ? [
                                              {
                                                label:
                                                  "Duration of Implisonment:",
                                                value:
                                                  info.criminalRecord.duration,
                                              },
                                            ]
                                            : []),
                                        ].map((item, index) => (
                                          <Grid
                                            item
                                            xs={12}
                                            key={index}
                                            container
                                          >
                                            <Grid
                                              item
                                              xs={5}
                                              style={{
                                                color: "#757575",
                                                fontWeight: "normal", fontSize: "12px",
                                              }}
                                            >
                                              {item.label}
                                            </Grid>
                                            <Grid
                                              item
                                              xs={7}
                                              style={{ fontWeight: "bold", fontSize: "12px" }}
                                            >
                                              {item.value}
                                            </Grid>
                                          </Grid>
                                        ))}
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                </Grid>
                              </CollapsibleDetailsSection>
                            </Card>
                          </Grid>
                        )}
                        {/* // ) : null} */}
                      </Grid>
                    </div>
                  )}

                </Card>
              </div>
             
                  <Box sx={{ width: "100%" }} className="no-print">
                    {info?.aboutTogoInLeave && isMe ? (
                      <Alert severity={"warning"}>
                        Your leave is starting soon. Please request someone to act
                        on your behalf if necessary{" "}
                      </Alert>
                    ) : null}

                     {(isMe || isLineManager || CheckHasAnyPermission(
                employeeOtherDetails,
                "read"
              )) && (
                <>
                    <Box
                      sx={{
                        borderBottom: 1,
                        borderColor: "divider",
                        marginLeft: { xs: 0, sm: "16px", md: "50px" },
                      }}
                    >
                      <Tabs
                        value={valueTab}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        sx={{
                          "& .MuiTabs-indicator": {
                            backgroundColor: "#1C7DB4",
                          },
                          "& .MuiTab-root": {
                            color: "#000000", // Black text for unselected tabs
                            fontSize: "13px",
                            lineHeight: "15.73px",
                            fontWeight: "400",
                          },
                          "& .Mui-selected": {
                            backgroundColor: mainBackground,
                            color: "#ffffff", // White text for selected tab
                            fontWeight: "600",
                            fontSize: "13px",
                            borderRadius: "8px",
                          },
                          "& .MuiTab-root.Mui-selected": {
                            color: "#ffffff",
                          },
                        }}
                        aria-label="basic tabs example"
                      >
                        <Tab label={<span>{"Projects"}</span>} {...a11yProps(0)} />
                        <Tab
                          label="Academic & Professional Documents"
                          {...a11yProps(1)}
                        />
                        <Tab label="Leave" {...a11yProps(2)} />
                        <Tab label="Meeting" {...a11yProps(3)} />
                        <Tab label="Worklog Report" {...a11yProps(4)} />
                      </Tabs>
                    </Box>
                    <TabPanel resourceId={id} value={valueTab} index={0}>
                      <div style={{ minHeight: "60vh" }}>
                        <ProjectWorkedOn
                          project={project?.projects}

                          resource={info.resource}
                          loggedUser={loggedUser}
                          resourceId={id}
                          SubmitGeneralForm={SubmitGeneralForm}
                          FetchDetails={FetchDetails}
                          mainBackground={mainBackground}
                        />
                      </div>
                    </TabPanel>

                    <TabPanel value={valueTab} index={1}>
                      <EmployeeDocuments
                        resourceId={id}
                        resource={info.resource}
                        openAttachment={attachmentOpen}
                        uploader={loggedUser?.id}
                        setOpen={() => setAttachmentOpen(false)}
                        onClose={() => {
                          setAttachmentOpen(false);
                        }}
                        onSuccess={success}
                      />
                    </TabPanel>

                    <TabPanel value={valueTab} index={2}>                     

                      <div style={{ minHeight: "60vh" }}>
                        <PersonalLeaves
                          resourceId={id}
                          resource={resource}
                          leaveList={leaveList}
                          FetchDetails={FetchDetails}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel value={valueTab} index={3}>
                      <div style={{ minHeight: "60vh" }}>
                        <MeetingAttended resource={resource} resourceId={id} meetingList={meetingList} FetchDetails={FetchDetails} />
                      </div>
                    </TabPanel>
                    <TabPanel value={valueTab} index={4}>
                      <div style={{ minHeight: "60vh" }}>
                        <ProfileWorklogReport resourceId={id} />
                      </div>
                    </TabPanel>
                  </>)}
                  </Box>
              
            </div>
          </div>
        </div>
      </div>
      {/* <ResourceFormDialog
        url={isMe ? "/api/profile/update" : undefined}
        positions={positions}
        master={loggedUser?.allowResource}
        open={openEdit}
        onSuccess={onSuccess}
        setOpen={setOpenEdit}
        id={id}
        technologies={technologies}
        value={value}
        setValue0={setValue0}
      /> */}
      <AllocateEmployee
        positions={positions}
        open={openAllocateEmployee}
        onSuccess={onSuccess}
        setOpen={setOpenAllocateEmployee}
        resourceId={id}
        value={value}
        setValue0={setValue0}
        structures={structures}
        wholeStructure={wholeStructure}
      />
      {/* <ResourceFormDialog url={'/api/profile/update'} positions={positions} master={loggedUser?.allowResource} open={openEdit} onSuccess={onSuccess} setOpen={setOpenEdit} id={id} institutions={institutions} departments={departments} divisions={divisions} offices={offices} technologies={technologies} value={value} setValue0={setValue0} /> */}
      <EducationEdit open={openEducation} onSuccess={onSuccess} setOpen={setOpenEducation} resourceId={id} value={value} setValue0={setValue0} />
      <ReferenceEdit open={openReference} onSuccess={onSuccess} setOpen={setOpenReference} resourceId={id} value={value} setValue0={setValue0} />
      <EmployementHistoryEdit open={openEmployement} onSuccess={onSuccess} setOpen={setOpenEmployment} resourceId={id} value={value} setValue0={setValue0} />
      <LeadershipEdit open={openLeadership} onSuccess={onSuccess} setOpen={setOpenLeadership} resourceId={id} value={value} setValue0={setValue0} />
      <CriminalRecordEdit open={openCriminalRecord} onSuccess={onSuccess} setOpen={setOpenCriminalRecord} resourceId={id} value={value} setValue0={setValue0} />
      <DiasporaDetailsEdit open={openDiaspora} onSuccess={onSuccess} setOpen={setOpenDiaspora} resourceId={id} value={value} setValue0={setValue0} />
      <RelativeDetailsEdit open={openRelative} onSuccess={onSuccess} setOpen={setOpenRelative} resourceId={id} value={value} setValue0={setValue0} />
      <ParentsEdit open={openParents} onSuccess={onSuccess} setOpen={setOpenParents} resourceId={id} value={value} setValue0={setValue0} />
      <CurrentResidenceEdit open={openCurrentResidence} onSuccess={onSuccess} setOpen={setOpenCurrentResidence} id={id} value={value} setValue0={setValue0} />
      <CivilStatusEdit open={openCivilStatus} onSuccess={onSuccess} setOpen={setOpenCivilStatus} resourceId={id} value={value} setValue0={setValue0} />
      <Acting onSuccess={loadData} hasPendingRequest={hasPendingRequest} setViewActing={setViewActing} viewActing={viewActing} open={openActing} setOpen={setOpenActing} FetchDetails={FetchDetails} actingOnBehalf={info?.actingOnBehalf} myActing={info?.myActing} />
      {/* <AddQualification onSuccess={() => ViewAllQualification(id)} open={openAddQualification} setOpen={setOpenAddQualification} id={qualificationId} title={value['title']} description={value['description']} /> */}

    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceProfile);
